import { useEffect } from 'react';
import { useSearchParams } from 'src/lib/routing';

import { setImpersonationToken } from 'utils/impersonation';

import type { ReactNode } from 'react';

export const AccessTokenSaver = ({ children }: { children: ReactNode }) => {
  const [params] = useSearchParams();

  useEffect(() => {
    // Read from ?token= search param (legacy)
    const searchToken = params.get('token');
    if (searchToken) {
      setImpersonationToken(searchToken);
      return;
    }

    // Read from URL fragment (new tab opened from impersonation banner)
    const hash = window.location.hash;
    if (hash.startsWith('#access_token=')) {
      const fragmentToken = hash.slice('#access_token='.length);
      setImpersonationToken(fragmentToken);
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }, [params]);

  return <>{children}</>;
};
